<div class="theme-container app-container">
    <div class="dropdowns">
        <!-- Client Dropdown -->
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="clientMenu"
            type="button"
        >
            Client
        </button>
        <mat-menu #clientMenu="matMenu">
            <section
                (click)="$event.stopPropagation()"
                *ngFor="let client of clients"
            >
                <mat-radio-button
                    name="selectedClientUuid"
                    ngDefaultControl
                    (click)="onClientSelect(client.clientUuid)"
                    [value]="client.clientUuid"
                    [(ngModel)]="selectedClientUuid"
                    [checked]="selectedClientUuid === client.clientUuid"
                >
                    {{ client.name }}
                </mat-radio-button>
            </section>
        </mat-menu>

        <!-- Game Dropdown -->
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="gameMenu"
            type="button"
        >
            Game
        </button>
        <mat-menu #gameMenu="matMenu">
            <section
                (click)="$event.stopPropagation()"
                *ngFor="let game of games"
            >
                <mat-radio-button
                    name="selectedGameCode"
                    ngDefaultControl
                    (click)="onGameSelect(game.gameCode)"
                    [value]="game.gameCode"
                    [(ngModel)]="selectedGameCode"
                    [checked]="selectedGameCode === game.gameCode"
                >
                    {{ game.name }}
                </mat-radio-button>
            </section>
        </mat-menu>

        <button
            mat-raised-button
            color="primary"
            (click)="resetFilters()"
            style="margin-left: 10px"
        >
            Reset filters
        </button>
    </div>

    <div
        class="selection-hint"
        *ngIf="!selectedClientUuid || !selectedGameCode"
    >
        Izaberite klijenta i igru da biste podesili boje.
    </div>

    <div
        class="message"
        [class.error]="messageIsError"
        *ngIf="message"
    >
        {{ message }}
    </div>

    <div
        class="theme-body"
        *ngIf="selectedClientUuid && selectedGameCode && !isLoading"
    >
        <!-- Editor -->
        <div class="token-list">
            <div
                class="token-row"
                *ngFor="let token of tokens"
            >
                <div class="token-meta">
                    <div class="token-label">{{ token.label }}</div>
                    <div class="token-description">{{ token.description }}</div>
                </div>
                <input
                    type="color"
                    class="token-picker"
                    [value]="colorPickerValue(token.key)"
                    (input)="onColorPicked(token.key, $any($event.target).value)"
                    [attr.aria-label]="token.label"
                />
                <input
                    type="text"
                    class="token-text"
                    [class.invalid]="!isValid(token.key)"
                    [value]="theme[token.key]"
                    (input)="onTextChanged(token.key, $any($event.target).value)"
                    [attr.aria-label]="token.label + ' hex'"
                />
            </div>
        </div>

        <!-- Live preview -->
        <div class="preview-pane">
            <div class="preview-title">Pregled</div>
            <div
                class="preview-ticket"
                [style.background]="theme['surface']"
                [style.color]="theme['text']"
            >
                <div
                    class="preview-header"
                    [style.background]="theme['headerBg']"
                >
                    Simulacija
                </div>
                <div
                    class="preview-card"
                    [style.background]="theme['surface2']"
                >
                    <span>Tim A - Tim B</span>
                    <span [style.color]="theme['accent']">2.35</span>
                </div>
                <div
                    class="preview-card"
                    [style.background]="theme['surface2']"
                >
                    <span [style.color]="theme['textMuted']">Rezultat</span>
                    <span [style.color]="theme['success']">Dobitak</span>
                </div>
                <div
                    class="preview-card"
                    [style.background]="theme['surface2']"
                >
                    <span [style.color]="theme['textMuted']">Rezultat</span>
                    <span [style.color]="theme['danger']">Gubitak</span>
                </div>
                <div
                    class="preview-input"
                    [style.background]="theme['surface3']"
                    [style.border-color]="theme['border']"
                >
                    100.00
                </div>
                <button
                    type="button"
                    class="preview-button"
                    [style.background]="theme['accent']"
                    [style.color]="theme['onAccent']"
                >
                    Potvrdi
                </button>
            </div>
        </div>
    </div>

    <div
        class="loading"
        *ngIf="isLoading"
    >
        Ucitavanje...
    </div>

    <!-- Buttons for Refresh, Reset, and Save -->
    <div
        class="action-buttons"
        *ngIf="selectedClientUuid && selectedGameCode"
    >
        <button
            mat-raised-button
            color="primary"
            (click)="refresh()"
            [disabled]="isLoading || isSaving"
        >
            Refresh
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="resetToDefault()"
            [disabled]="isLoading || isSaving"
        >
            Vrati na default
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="saveTheme()"
            [disabled]="isLoading || isSaving || hasInvalidValues"
        >
            Sacuvaj
        </button>
    </div>
</div>
